import type { MouseEvent } from 'react'

/**
 * Un solo puntero arrastra a la vez, así que el estado del arrastre puede vivir en el módulo:
 * no hay dos modales compitiendo por él ni aunque haya dos abiertos.
 */
let arrastreIniciadoDentro = false

/**
 * Props del telón de un modal: cerrar al hacer clic fuera del panel, pero NO al soltar fuera
 * un arrastre que empezó dentro.
 *
 * El `click` de React se dispara sobre el ancestro común de `mousedown` y `mouseup`. Al
 * arrastrar para seleccionar un UUID, un importe o un motivo dentro del panel y soltar un
 * pixel afuera, ese ancestro es el telón: `e.target === e.currentTarget` daba verdadero y el
 * modal se cerraba encima de lo que la persona estaba copiando, perdiendo lo capturado.
 * Detener la propagación en el panel no lo evita, porque el clic nunca pasó por el panel.
 *
 * Uso: `<div className="modal" {...telon(() => alCerrar())}>`.
 */
export function telon(cerrar: () => void) {
  return {
    onMouseDown: (e: MouseEvent) => {
      arrastreIniciadoDentro = e.target !== e.currentTarget
    },
    onClick: (e: MouseEvent) => {
      const clicLimpioEnElTelon = !arrastreIniciadoDentro && e.target === e.currentTarget
      arrastreIniciadoDentro = false
      if (clicLimpioEnElTelon) cerrar()
    },
  }
}
